import React from "react";
import { AuthConsumer } from "./context";

const Authorized = ({ children }) => (
  <AuthConsumer>{({ userInfo }) => (userInfo ? children : null)}</AuthConsumer>
);

export default Authorized;
